import React from 'react'
import Explainslide from './Explainslide'
import { Helmet } from 'react-helmet-async'

const Explain = () => {
  return (
    <>
      <Helmet>
        <title>🐝｜ルール説明</title>
      </Helmet>


      <Explainslide />
    </>
  )
}

export default Explain
